import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {ApplicationService} from '../../../services';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { NgIf, NgFor } from '@angular/common';
import {DataHandlerService} from '../../../services/data-handler.service';

@Component({
    selector: 'app-address-suggestions',
    templateUrl: 'address-suggestions.component.html',
    standalone: true,
    imports: [NgIf, NgFor]
})
export class AddressSuggestionsComponent implements OnInit, OnDestroy {
  private personList = [];
  private trustList = [];
  private companyList = [];
  @Input() public formGroup;
  @Input() public control;
  public availableAddresses = [];
  unsubscribe$ = new Subject();

  constructor(private applicationService: ApplicationService,
              public dataHandlerService: DataHandlerService) {
  }

  ngOnInit() {
    this.applicationService.addresses$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (data: any) => {
        console.debug('applicationService.addresses');
        if (data) {
          this.personList = data.personList ? data.personList : [];
          this.companyList = data.companyList ? data.companyList : [];
          this.trustList = data.trustList ? data.trustList : [];
        }
        this.extractAvailableAddresses();
      }
    );
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  extractAvailableAddresses() {
    let allAddresses = [];

    if (this.personList.length > 0) {
      const personAddresses = _.map(this.personList, p => {
        const arr = [];
        arr.push(p.homeAddress);
        arr.push(p.postalAddress);
        arr.push(p.postSettlementAddress);

        if (p.previousAddresses && p.previousAddresses.length > 0) {
          p.previousAddresses.forEach((address: any) => {
            arr.push(address.previousAddress);
          });
        }

        return arr;
      });
      allAddresses = allAddresses.concat(personAddresses);
    }

    if (this.companyList.length > 0) {
      const companyAddresses = _.map(this.companyList, p => {
        const arr = [];
        arr.push(p.tradingAddress);
        arr.push(p.postalAddress);
        arr.push(p.postSettlementAddress);
        return arr;
      });
      allAddresses = allAddresses.concat(companyAddresses);
    }

    if (this.trustList.length > 0) {
      const trustAddresses = _.map(this.trustList, p => {
        const arr = [];
        arr.push(p.tradingAddress);
        arr.push(p.postalAddress);
        arr.push(p.postSettlementAddress);
        return arr;
      });
      allAddresses = allAddresses.concat(trustAddresses);
    }

    // console.log('allAddresses', allAddresses);

    this.availableAddresses = _.chain(allAddresses)
      .flatten()
      .filter(e => e && e.fullAddress && e.streetType && e.postcode && e.country && e.stateId && e.suburb && e.streetNumber)
      .uniqBy('fullAddress')
      .value();
  }

  /**
   * Patch Security Address from the address links available
   * @param address
   */
  patchAddressField(address: any) {
    console.log('patch address', address);

    if (this.formGroup.controls[this.control]) {
      this.formGroup.controls[this.control].patchValue(address, {emitEvent: false});
      this.formGroup.controls[this.control].updateValueAndValidity();
      this.formGroup.controls[this.control].markAsTouched();
    }
  }
}
